import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IBillingDetailsResponse } from "../patients/index.type";

const useGetBillingDetailsPage = ({
  billingCycleId,
}: {
  billingCycleId?: string;
}) => {
  const [reportBillingDetails, setReportBillingDetails] =
    React.useState<IBillingDetailsResponse>();

  const { loading: getAllDetailsLoading, makeApiCall } = useApi({
    method: "GET",
    url: `/rtm/patient-dashboard/cron/pdf/v3/billing-details/${billingCycleId}`,
    preAuth: true,
  });

  const getBillingDetails = async () => {
    if (!billingCycleId) return;

    const { response, error } = await makeApiCall<
      undefined,
      IBillingDetailsResponse
    >();

    if (response) {
      setReportBillingDetails(response);
    } else if (error) {
      toast.error(error.msg);
      setReportBillingDetails(undefined);
    }
  };

  return { getBillingDetails, reportBillingDetails, getAllDetailsLoading };
};

export default useGetBillingDetailsPage;
